import React from 'react';
import PropTypes from 'prop-types';

import UriFiltering from 'utils/UriFiltering';

const withFiltering = (WrappedComponent) => {
  const FilteredComponent = (props) => {
    const { location } = props;
    const uriFiltering = new UriFiltering(location);
    const filters = uriFiltering.getFilters();
    const setFilters = (newFilters, options = {}) => uriFiltering.setFilters(newFilters, options);

    return <WrappedComponent {...props} filters={filters} setFilters={setFilters} />;
  };

  FilteredComponent.propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      search: PropTypes.string
    }).isRequired
  };

  return FilteredComponent;
};

withFiltering.propTypes = {
  WrappedComponent: PropTypes.element
};

export default withFiltering;
